import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoRepediuForm } from "./components/IntegracaoRepediuForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Repediu" />
            <Loading />
            <IntegracaoRepediuForm />
        </>
    )
}
